<template>
    <div class="usercomments"> 
        <div class="commenttitle vCenter">
            <div class="ctitle">留下您的评论</div>
            <div class="totalNumber"><span>{{total}}</span>条评论</div>
        </div>
        <div class="minecomments clearfix">
            <!-- <div class="fl">
                <div v-show="avatar==''||avatar==undefined" class="defaultAvatar useravatar">{{getShortName(sumname)}}</div>
                <img class="useravatar" :src="avatar" v-show="avatar!=''&&avatar!=undefined" alt="">
            </div>
            <div class="fl">
                <textarea name="" id="" cols="30" rows="10" v-model="usercomments"></textarea>
                <div class="clearfix">
                    <div @click="send()" class="send fr">发送</div>
                </div>
            </div> -->
            <div class="cuseravatar">
                <div v-show="avatar==''||avatar==undefined" class="defaultAvatar useravatar40">{{getShortName(sumname)}}</div>
                <img class="useravatar40" :src="avatar" v-show="avatar!=''&&avatar!=undefined" alt="">
            </div>
            <div class="sendcommentdiv">
                <div class="input-wrap focus">
                    <textarea name="" class="tafocus" v-model="usercomments" placeholder="写下您的评论..."></textarea>
                </div>
                
                <div class="clearfix cbtnsdiv focus">
                    <div @click="send()" class="send fr">发送</div>
                </div>
            </div>
        </div>
        <div class="commenttitle vCenter" v-if="showNewComment" v-show="total>0">
            <div class="ctitle">最新评论</div>
        </div>
        <div class="othercomments" v-if="showNewComment" v-show="total>0">
            <ul>
              <li class="clearfix" v-for="item, index in review" :data-dappuuid=item.dappuuid>
                <div class="fl left">
                    <div v-show="item.avatar==''||item.avatar==undefined" class="defaultAvatar">{{getShortName(item.sumname)}}</div>
                    <img :src="item.avatar" v-show="item.avatar!=''&&item.avatar!=undefined" alt="">
                </div>
                <div class="fl right">
                    <div>
                        <span class="replyname">{{item.sumname}}</span>
                        <span class="replytime">{{item.createdate}}</span>
                    </div>
                    <div class="replycontent">
                        {{item.stext}}
                    </div>
                    <div class="replyoperation clearfix">   
                        <div class="fr">
                            <div class="clearfix evaluation">
                                <div class="fl vCenter" @click="ding(item.sid)">
                                    <img :src="item.mineding=='1'? '/img/icon/zaned.png' : '/img/icon/zan.png'" alt="">
                                    <!-- {{item.mineding=='1'?'取消顶':'顶'}} -->
                                    <span>
                                      {{parseInt(item.dingcount)}}
                                    </span>
                                </div>
                                <div class="fl vCenter" @click="cai(item.sid)">
                                    <img :src="item.minecai=='1'? '/img/icon/caied.png' : '/img/icon/cai.png'" alt="">
                                    <!-- {{item.minecai=='1'?'取消踩':'踩'}} -->
                                    <span>
                                      {{parseInt(item.caicount)}}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                  </div>
              </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
  name: "UmMcomment",
  data() {
    return {
      reviewtype:0,
      usercomments:'',
      page:0,
      pagesize:4,
      totalpage:0,
      total:0,
      umid: '',
      parentreviewid: '',
      review:[],
      loadStatus: true,
      status: true,
    };
  },
  props: {
    avatar: String,
    sumname: String,
    sid: String,
    appid: String,
    reviewcount: String,
    showNewComment: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    var that = this;
    // that.umid=$UMCore.uncompile("umid")
    var waitReady = function() {
      if (that.sid != '' && that.sid != undefined) {
        that.umid=$UMCore.uncompile("umid")
        that.getreview()
        if ($UMCore.uncompile('token')!=null) {
            var commenttype = localStorage.getItem("commenttype") 
            if(commenttype == 1) {
                that.usercomments = localStorage.getItem("comment")
                that.usercommentsfun()
            } else if(commenttype == 2) {
                var sid = localStorage.getItem("commentsid")
                that.cai(sid)
            } else if(commenttype == 3) {
                var sid = localStorage.getItem("commentsid")
                that.ding(sid)
            }
        }
        localStorage.removeItem("commenttype") 
        localStorage.removeItem("comment") 
        localStorage.removeItem("commentsid") 
      } else {
        setTimeout(function() {
          waitReady();
        }, 20);
      }
    };
    setTimeout(function() {
      waitReady();
    }, 50);
    
  },
  methods: {
    getreview(){
      var that = this;
      that.umid=$UMCore.uncompile("umid")
      $UMCore.post("/route.lua", {
          data:JSON.stringify({
            functionname:"comments_getlist",
            dappuuid: that.sid,
            page:that.page,
            pagesize:that.pagesize,
            umid:that.umid
          })
        })
        .then(function(response) {
          if (response.data.code == 0) {
            that.totalpage = response.data.totalpage
            that.total = response.data.total
            // that.review = response.data.slist
            let arr = response.data.slist
            if (arr.length == 0) {
              that.loadStatus = false
              that.status = true
            } else {
              arr.forEach((val)=>{
                that.review.push(val)
              })
              that.status = true
            }
            // for (var i = 0; i < that.review.length; i++) {
            //   that.$set(that.review[i], 'clickNum', -1)
            //   that.$set(that.review[i], 'clickNum1', -1)
            // }
          } else if (response.data.code == 1) {
            that.$message.error("网络错误2！");
          } else {
            that.$message.error("请登录！");
          }
        })
        .catch(function(error) {
          console.log(error);
          that.$message.error("网络错误3！");
          return false;
        });
    },
    /**
     * 获取新闻相关内容（详情，评论）
     */
    api(){
      var that=this
      that.umid=$UMCore.uncompile("umid")
      console.log(JSON.stringify({
            functionname:"comments_set",
            dappid:that.appid,
            edittype:that.edittype,
            dappuuid: that.sid,
            itype: that.reviewtype,
            stext:that.usercomments,
            umid:that.umid,
            parentid:that.parentreviewid
         }))
      $UMCore
        .post("/route.lua", {
         data:JSON.stringify({
            functionname:"comments_set",
            dappid:that.appid,
            edittype:that.edittype,
            dappuuid: that.sid,
            itype: that.reviewtype,
            stext:that.usercomments,
            umid:that.umid,
            parentid:that.parentreviewid
         })
        })
        .then(function(response) {
          if (response.data.status) {
            that.usercomments = ''
            if(that.reviewtype==1) {
              that.loadStatus = true;
              that.status = true;
              that.page=0
              that.review=[]
              that.getreview()
              that.$emit("resetList", "")
            }
          } else {
            that.$message({ message: '失败', type: 'error', customClass: 'popupMessage' })
          }
        })
        .catch(function(error) {
          console.log(error);
          that.$message.error("网络错误！");
          return false;
        });
    },
    /**
     * 发送新闻评论内容
     */
    usercommentsfun(){
        var that = this;
        if ($UMCore.uncompile('token')==null) {
            // this.openloginview()
        } else {
            var that=this;
            that.reviewtype=1
            if(that.usercomments!=''){
              that.api();
              // that.detailInfo.reviewcount=parseInt(that.detailInfo.reviewcount)+1;
              that.reviewcount = parseInt(that.reviewcount) + 1
              this.$emit('retcomment',that.reviewcount);
              // that.loadStatus = true;
              // that.status = true;
              // that.page=0
              // that.review=[]
              // that.getreview()
            }else{
              that.$message({message: '不能发送空信息',type: 'error',customClass:'popupMessage'});
            }
        }
    },
    caifun(id){
      var that = this;
      that.parentreviewid=id;
      that.reviewtype=3;
      that.api();
      for(var j=0;j<that.review.length;j++){
        if(id==that.review[j].sid){
          if(that.review[j].minecai==='1'){
            that.review[j].minecai='0';
            that.review[j].caicount=that.review[j].caicount-1;
            break;
          }else if((that.review[j].minecai==='0')&&(that.review[j].mineding==='1')){
            that.review[j].caicount=parseInt(that.review[j].caicount)+1;
            that.review[j].dingcount=that.review[j].dingcount-1;
            that.review[j].minecai='1';
            that.review[j].mineding='0';
            break;
          }else{
            that.review[j].minecai='1';
            that.review[j].caicount=parseInt(that.review[j].caicount)+1;
            break;
          }
        }
      }
    },
    /**
     * 新闻评论顶
     */
    dingfun(id){
      var that = this;
      that.parentreviewid=id;
      that.reviewtype=2;
      that.api();
      for(var j=0;j<that.review.length;j++){
        if(id==that.review[j].sid){
          if(that.review[j].mineding==='1'){
            that.review[j].mineding='0';
            that.review[j].dingcount=that.review[j].dingcount-1;
            break;
          }else if((that.review[j].minecai==='1')&&(that.review[j].mineding==='0')){
            that.review[j].caicount=that.review[j].caicount-1;
            that.review[j].dingcount=parseInt(that.review[j].dingcount)+1;
            that.review[j].minecai='0';
            that.review[j].mineding='1';
            break;
          }else{
            that.review[j].mineding='1';
            that.review[j].dingcount=parseInt(that.review[j].dingcount)+1;
            break;
          }
        }
      }
    },
    changepage() {
        var that = this;
        if(that.loadStatus && that.status) {
            that.status = false;
            that.page++
            that.getreview()
        }
    },
    getShortName(sname) {
        if(sname != undefined && sname.length > 2) {
            return sname.substr(sname.length-2,2);
        }
        if(this.umid == '' || this.umid == undefined) {
           return '未登录'
        }
        return sname;
    },
    send() {
        // this.$emit('retusercomments',this.usercomments);
        if ($UMCore.uncompile('token')==null) {
            localStorage.setItem("commenttype", 1)
            localStorage.setItem("comment", this.usercomments)
            this.$emit('unlogin','');
        } else {
            this.usercommentsfun()
            this.usercomments=''
        }
    },
    cai(sid){
        // this.$emit('retcai',sid);
        if ($UMCore.uncompile('token')==null) {
            localStorage.setItem("commenttype", 2)
            localStorage.setItem("commentsid", sid)
            this.$emit('unlogin','');
        } else {
            this.caifun(sid)
        }
    },
    ding(sid){
        // this.$emit('retding',sid);
        if ($UMCore.uncompile('token')==null) {
            localStorage.setItem("commenttype", 3)
            localStorage.setItem("commentsid", sid)
            this.$emit('unlogin','');
        } else {
            this.dingfun(sid)
        }
    },
  }
};
</script>
<style lang="scss" scoped>
.usercomments {
  .commenttitle {
    // border-left: 3px solid #0e8de6;
    justify-content: space-between;
    font-size: 16px;
    color: #444;
    .ctitle {
      // padding: 0 10px;
    }
    .totalNumber {
      font-size: 14px;
      color: #0e8de6;
    }
  }  
  .minecomments {
    margin: 20px 0;
    box-sizing: border-box;
    display: flex;
    .cuseravatar {
      float: left;
      display: block;
      width: 50px;
      // margin-right: 15px;
    }
  }
  .othercomments {
    margin-top: 20px;
    ul {
      border-top: 1px solid #dcdcdc;
      padding: 10px 0;
      li {
        border-bottom: 1px dashed #dcdcdc;
        padding: 10px 0;
      }
    }
    .left {
      img{ 
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 10px;
        object-fit: cover;
      }
    }
    .right {
      // width: 80%;
      width: calc(100% - 50px);
      .replyname {
        margin-right: 10px;
      }
      .replyname{
        font-size: 14px;
        color: #0e8de6;
        display: inline-block;
        margin-bottom: 10px;
      }
      .replytime {
        font-size: 14px;
        color: #999;
        display: inline-block;
        margin-bottom: 10px;
        float: right;
      }
      .replycontent {
        font-size: 14px;
        color: #333;
        width: 100%;
        margin-bottom: 10px;
      }
      .replyoperation {
        justify-content: space-between;
        margin-bottom: 10px;
        .replyBtn {
          color: #3064ea;
          font-size: 14px;
          margin-right: 10px;
          cursor: pointer;
        }
        .replynum {
          color: #999;
          margin-right: 10px;
        }
        .evaluation {
          img {
            width: 14px;
            height: 14px;
          }
          div {
            color: #999;
            margin-left: 10px;
            cursor: pointer;
          }
          span {
            margin-left: 6px;
          }
        }
      }
    }
  }
  // textarea {
  //   width: 270px;
  //   height: 80px;
  //   border: 1px solid #dcdcdc;
  //   resize: none;
  //   outline: none;
  //   padding: 10px;
  //   margin-left: 10px;
  // }
  // .send {
  //   width: 60px;
  //   height: 30px;
  //   line-height: 30px;
  //   text-align: center;
  //   font-size: 14px;
  //   color: #fff;
  //   background: #0e8de6;
  //   cursor: pointer;
  //   margin-top: 10px;
  // }
}
.defaultAvatar {
  width: 40px;
  height: 40px;
  color: #fff;
  text-align: center;
  line-height: 40px;
  border-radius: 50%;
  font-size: 12px;
  // margin-right: 15px;
  background: #0e8de6;
  opacity: 0.85;
}
.useravatar40 {
    width: 40px;
    height: 40px;
    color: #fff;
    text-align: center;
    line-height: 42px;
    border-radius: 50%;
    margin-right: 10px;
    display: inline-block;
}
.useravatar{
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
    text-align: center;
    line-height: 40px;
}
.sendcommentdiv {
  border: 1px solid #dcdcdc;
  border-radius:5px;
  position: relative;
  font-size: 16px;
  color: #bababa;
  // border: 1px solid #3f404c;
  background: #fff;
  box-sizing: content-box;
  // width: 86%;
  flex:1;
  min-height: 40px;
  height: 100%;
  overflow: hidden;
  
  
  .input-wrap {
    textarea{
        transition: all .4s;
    }
      .tafocus {
        width: 100%;
        // height: 110px;
        border: 0px;
        resize: none;
        outline: none;
        padding: 10px;
        color: #666;
      }
      .tanotfocus {
        display: block;
        font-size: 16px;
        width: 100%;
        height: 30px;
        resize: none;
        border: 0;
        outline: 0;
        padding: 10px;
        border: 0px solid #dcdcdc;
      }
  }
  
  .cbtnsdiv {
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 0;
    border: none;
    height: 30px;
    .send {
      float: right;
      width: 80px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      font-size: 14px;
      color: #fff;
      background: #0e8de6;
      cursor: pointer;
      border-radius:0px 0px 5px 0px;
    }
  }
}
// .input-wrap.focus {
//   // height: 100%
// }
.cbtnsdiv.focus {
    position: relative;
    background-color: #f4f5f6;
    bottom: 0;
    right: 0;
    padding: 0;
    border: none;
    height: 30px;
}
.input-wrap.focus textarea {
    height: 80px;
}
</style>




// WEBPACK FOOTER //
// src/packages/mcomment/um-mcomment.vue